export const COMPONENTS_TRANSLATION_NAMESPACE = "components";

export const SELECTOR_TK = "SELECTOR_TK";
